export enum DataType {
  Event = 0,
  Data = 1,
}
